import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFacebook = (props) => /* @__PURE__ */ _jsx("svg", {
	height: 23,
	viewBox: "0 0 12 23",
	width: 12,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m45.546798 5.40433376v3.0145211h-3.546798v4.08915804h3.546798v10.4919871h4.2422487v-10.4919871h3.5381049l.530281-4.08915804h-4.0683859v-2.61131592c0-1.18192762.330339-1.98833798 2.0359316-1.98833798l2.1750217-.00173049v-3.6565345c-.3755433-.05191483-1.6673428-.16093597-3.1695161-.16093597-3.1364822 0-5.2836859 1.90527425-5.2836859 5.40433376",
		fillRule: "evenodd",
		transform: "translate(-42)"
	})
});
export default SvgFacebook;
